const TEXT = {
    ACHIEVEMENT_CONTENT_TEXT_1:"我的业绩",
    ACHIEVEMENT_CONTENT_TEXT_2:"个人业绩",
    ACHIEVEMENT_CONTENT_TEXT_3:"当前未开启月任务",
    ACHIEVEMENT_CONTENT_TEXT_4:"月团队业绩",
    ACHIEVEMENT_CONTENT_TEXT_5:"团队人数",
    ACHIEVEMENT_CONTENT_TEXT_6:"直推人数",
    ACHIEVEMENT_CONTENT_TEXT_7:"月团队奖励",
};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/achievement/index.js